import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ name: 'draft_message', namespaced: true })
export default class DraftMessage extends VuexModule {
  public message: string = '';

  @Mutation
  public setDraftMessage(message: string) {
    this.message = message;
  }

  @Mutation
  public clearDraftMessage() {
    this.message = '';
  }

  @Action({ rawError: true })
  public updateDraft(message: string) {
    this.context.commit('setDraftMessage', message);
  }

  @Action({ rawError: true })
  public resetDraft() {
    this.context.commit('clearDraftMessage');
  }
}
